import {createStyles, WithStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

export const styles = (theme: Theme) => createStyles({
    wrapText: {
        marginBottom: 10
    },
    card: {
        marginBottom: '15px',
        borderLeft: '3px solid transparent'
    },
    content: {
        padding: '8px 16px 0 16px'
    },
    actions: {
        display: 'flex',
        padding: '0'
    },
    element: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        })
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    arrow: {
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        transform: 'translateX(-50%)',
        top: '60px'
    },
    icon: {
        width: '40px',
        height: '40px',
        padding: '10px',
        margin: 0,
        borderRadius: '50%',
        backgroundColor: '#fafafa',
        color: '#555',
        boxShadow: `0px 1px 3px 0px rgba(0,0,0,0.2),
        0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);`
    },
    boldText: {
        fontWeight: 500
    },
    editor: {
        width: 'auto',
        fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
        [theme.breakpoints.down('sm')]: {
            width: 400
        },
        [theme.breakpoints.between('sm', 'md')]: {
            width: 700
        },
        [theme.breakpoints.up('md')]: {
            width: 900
        }
    },
    message: {
        fontWeight: 500,
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '0.875rem',
        fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
        lineHeight: '1.5'
    },
    rating: {
        color: '#1565C0',
        display: 'inline-block',
        width: 75,
        textAlign: 'right'
    },
    messageIcon: {
        color: '#555'
    }
});

export type Classes = WithStyles<typeof styles>
